/** Chave pública (site key) do reCAPTCHA v3, usada quando a variável de build não vem preenchida. */
const DEFAULT_SITE_KEY = '6LcRA-0nAAAAAJSSZH2kPGTWPH9quLDJOzSs-KpV';

/**
 * Usa `||` (e não `??`) de propósito: o `--build-arg` do Docker chega como string vazia quando a variável
 * não está cadastrada no pipeline, e uma chave vazia faz o provider não carregar o reCAPTCHA
 * ("recaptcha key not provided"), travando os formulários de orçamento e de cadastro.
 */
export function resolveSiteKey(fromEnv: string | undefined): string {
  const key = fromEnv?.trim();

  return key ? key : DEFAULT_SITE_KEY;
}
